// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".krry-main[data-v-50febcff] {\n  min-width: 600px;\n}\n.inner-center[data-v-50febcff] {\n  margin: 0 5px;\n}\n.opera[data-v-50febcff] {\n  position: relative;\n  width: 100px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.opera .el-button.is-circle[data-v-50febcff] {\n    border-radius: 50%;\n    padding: 12px;\n    display: block;\n    margin: 25px auto;\n}\n", ""]);
// Exports
module.exports = exports;
